import type { ComponentPropsWithoutRef, FC } from 'react';

import { cn } from '@wwe-portal/ui/lib/lib';

export const Skeleton: FC<ComponentPropsWithoutRef<'div'>> = ({
  className,
  ...props
}) => {
  return (
    <div
      className={cn(
        'bg-text600 animate-pulse rounded-md opacity-90',
        className
      )}
      {...props}
    />
  );
};

export const TextSkeleton: FC<
  ComponentPropsWithoutRef<'div'> & {
    fontSize: number;
    lineHeight: number;
  }
> = ({ className, fontSize, lineHeight, style, ...props }) => {
  return (
    <div
      className={cn('flex items-center justify-stretch', className)}
      style={{
        height: lineHeight,
      }}
    >
      <div
        className="bg-text600 w-full animate-pulse rounded-md opacity-90"
        style={{
          ...style,
          height: fontSize,
        }}
        {...props}
      />
    </div>
  );
};
